<div id="dialog_container" class="small_dialog_container">
  <div id="upper_band" class="upper-band upper-band-color"></div>
  <div id="middle_band" class="center-band center">
    <img
      id="delete_icon"
      src="/assets/images/error-icon.svg"
      alt="error"
      width="100"
      class="image-icon" />
    <span class="text-content">
      <div id="title" class="title">{{ title() }}</div>
      <div id="message" class="message" [innerHTML]="message()"></div>
      <div id="para" class="para">{{ paragraph() }}</div>
    </span>
  </div>
  <hr class="custom-hr" />
  <div id="lower_band" class="lower-band">
    <button
      mat-button
      id="confirm_button"
      class="red-button common-button"
      (click)="dialog.close(true)">
      {{ buttonConfirm() }}
    </button>
    <button
      mat-button
      id="cancel_button"
      class="white-button common-button"
      (click)="dialog.close(false)">
      {{ buttonCancel() }}
    </button>
  </div>
</div>
